
// // AppHeader.jsx - TALLER Header with Bigger Centered Logo
// import React, { useEffect, useState } from "react";
// import { useLocation, useNavigate } from "react-router-dom";
// import "./AppHeader.css";
// import { useMessagesUI } from "../context/MessagesContext";
// import { getUnreadCount } from "../services/messagesApi";
// import { FaBell } from "react-icons/fa";

// const AppHeader = ({ isSidebarVisible, toggleSidebar }) => {
//   const navigate = useNavigate();
//   const location = useLocation();

//   const { pathname } = location;
//   const showSearchForMembers = pathname.includes("members");
//   const showSearchForEvents = pathname.includes("events");

//   const { openMessages } = useMessagesUI();
//   const [unread, setUnread] = useState(0);

//   useEffect(() => {
//     let alive = true;

//     const load = async () => {
//       try {
//         const result = await getUnreadCount();

//         let count = 0;
//         if (typeof result === "number") {
//           count = result;
//         } else if (typeof result === "object" && result !== null) {
//           count = Number(result.count ?? result.unread ?? result.cnt ?? 0);
//         }

//         const finalCount = Number.isFinite(count) ? count : 0;

//         if (alive) {
//           setUnread(finalCount);
//         }
//       } catch (error) {
//         console.error("Error fetching unread count:", error);
//         if (alive) {
//           setUnread(0);
//         }
//       }
//     };

//     load();
//     const id = setInterval(load, 30000);
//     return () => {
//       alive = false;
//       clearInterval(id);
//     };
//   }, []);

//   const unreadCount = Number(unread) || 0;
//   const hasUnread = unreadCount > 0;

//   return (
//     <header
//       className="app-header"
//       style={{
//         position: "fixed",
//         top: 0,
//         left: 0,
//         right: 0,
//         width: "100%",
//         zIndex: 1000,
//         backgroundColor: "#01057a",
//         boxShadow: "0 2px 4px rgba(0,0,0,0.2)",
//         height: "120px", // keeps the header height consistent
//         display: "flex",
//         alignItems: "center",
//         justifyContent: "center",
//         padding: "0 20px",
//       }}
//     >
//       {/* Inner container so we can absolutely position children
//           without changing the header size */}
//       <div
//         style={{
//           position: "relative",
//           width: "100%",
//           height: "100%",
//         }}
//       >
//         {/* Centered Logo (still toggles sidebar on click) */}
//         <div
//           onClick={toggleSidebar}
//           style={{
//             cursor: "pointer",
//             display: "flex",
//             alignItems: "center",
//             justifyContent: "center",
//             height: "100%",
//             flexShrink: 0,
//             position: "absolute",
//             top: "50%",
//             left: "50%",
//             transform: "translate(-50%, -50%)", // fixed center
//           }}
//         >
//           <img
//             src="/images/onscreen.png"
//             alt="On Screen"
//             style={{
//               height: "55px", // BIGGER - was 45px
//               width: "auto",
//               maxWidth: "210px",
//               objectFit: "contain",
//               display: "block",
//             }}
//           />
//         </div>

//         {/* Message Bell - fixed to top-right of the header */}
//         <div
//           style={{
//             position: "absolute",
//             top: 0,
//             right: 0,
//             height: "100%",
//             display: "flex",
//             alignItems: "flex-start",
//             justifyContent: "flex-end",
//             flexShrink: 0,
//             paddingTop: "8px",
//             paddingRight: "8px",
//           }}
//         >
//           <button
//             onClick={(e) => {
//               e.preventDefault();
//               openMessages();
//               if (isSidebarVisible) toggleSidebar();
//             }}
//             style={{
//               position: "relative",
//               background: "none",
//               border: "none",
//               padding: "10px 15px",
//               cursor: "pointer",
//               display: "flex",
//               alignItems: "center",
//               justifyContent: "center",
//               minWidth: "48px",
//               minHeight: "48px",
//             }}
//             title={
//               hasUnread
//                 ? `${unreadCount} unread message${unreadCount !== 1 ? "s" : ""}`
//                 : "Messages"
//             }
//             aria-label="Messages"
//           >
//             <FaBell
//               size={28} // Slightly bigger bell too
//               style={{
//                 color: hasUnread ? "#ff6800" : "#ffffff",
//                 transition: "color 0.3s ease",
//                 filter: hasUnread
//                   ? "drop-shadow(0 0 6px rgba(255, 104, 0, 0.8))"
//                   : "none",
//               }}
//             />
//             {hasUnread && (
//               <span
//                 style={{
//                   position: "absolute",
//                   top: "8px",
//                   right: "8px",
//                   backgroundColor: "#ff6800",
//                   color: "#ffffff",
//                   borderRadius: "50%",
//                   padding: "3px 7px",
//                   fontSize: "0.75rem",
//                   fontWeight: "bold",
//                   minWidth: "22px",
//                   height: "22px",
//                   display: "flex",
//                   alignItems: "center",
//                   justifyContent: "center",
//                   lineHeight: "1",
//                   border: "2px solid #ffffff", // <-- fixed line
//                   boxShadow: "0 2px 4px rgba(0,0,0,0.3)",
//                 }}
//               >
//                 {unreadCount > 99 ? "99+" : unreadCount}
//               </span>
//             )}
//           </button>
//         </div>
//       </div>
//     </header>
//   );
// };

// export default AppHeader;


// AppHeader.jsx - Header with integrated MessagesBell component
import React from "react";
import { useLocation } from "react-router-dom";
import "./AppHeader.css";
import MessagesBell from "./messages/MessagesBell"; // ⭐ Import the MessagesBell component

const AppHeader = ({ isSidebarVisible, toggleSidebar }) => {
  const location = useLocation();
  const { pathname } = location;

  // Keep your existing logic for search visibility if needed
  const showSearchForMembers = pathname.includes("members");
  const showSearchForEvents = pathname.includes("events");

  // =====================================================
  // Callback for MessagesBell - closes sidebar before opening messages
  // =====================================================
  const handleBeforeOpenMessages = () => {
    if (isSidebarVisible) {
      toggleSidebar();
    }
  };

  return (
    <header
      className="app-header"
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        width: "100%",
        zIndex: 1000,
        backgroundColor: "#01057a",
        boxShadow: "0 2px 4px rgba(0,0,0,0.2)",
        height: "120px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "0 20px",
      }}
    >
      {/* Inner container for absolutely positioned children */}
      <div
        style={{
          position: "relative",
          width: "100%",
          height: "100%",
        }}
      >
        {/* Centered Logo (toggles sidebar on click) */}
        <div
          onClick={toggleSidebar}
          style={{
            cursor: "pointer",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            height: "100%",
            flexShrink: 0,
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
          }}
        >
          <img
            src="/images/onscreen.png"
            alt="On Screen"
            style={{
              height: "55px",
              width: "auto",
              maxWidth: "210px",
              objectFit: "contain",
              display: "block",
            }}
          />
        </div>

        {/* 
          ⭐ Message Bell Component - fixed to top-right 
          
          This MessagesBell component:
          - Automatically turns ORANGE (#ff6800) when unread count > 0
          - Automatically turns WHITE when unread count = 0
          - Polls backend every 30 seconds for updated count
          - Listens for real-time events (new-message, message-read, unread:refresh)
          - Shows badge with count when there are unread messages
          - Closes sidebar before opening messages modal
        */}
        <div
          style={{
            position: "absolute",
            top: 0,
            right: 0,
            height: "100%",
            display: "flex",
            alignItems: "flex-start",
            justifyContent: "flex-end",
            flexShrink: 0,
            paddingTop: "8px",
            paddingRight: "8px",
          }}
        >
          <MessagesBell 
            size={28} 
            onBeforeOpen={handleBeforeOpenMessages}
          />
        </div>
      </div>
    </header>
  );
};

export default AppHeader;